import { objectWithoutProperties as _objectWithoutProperties, objectSpread2 as _objectSpread2, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useMemo } from 'react';
import { useSafeThemeUI } from '../../../theme-provider/use-theme-ui.esm.js';
import { getSafeTransparentize } from '../../../utils/colors.esm.js';
import extractStringNodes from '../../../utils/extract-string-nodes.esm.js';
import { omit, EMPTY_OBJECT } from '../../../utils/object.esm.js';
import { resolveColor } from '../../../utils/styled-props.esm.js';
import { BoxPrivate } from '../box/box.esm.js';
import { TextPrivate } from '../text/text.esm.js';
import { createUseStyledComponent } from '../../../hooks/use-styled-component.esm.js';

var _excluded = ["absolute", "as", "flexItem", "orientation", "light", "role", "color", "bg", "backgroundColor", "height", "resetCss", "width", "children"];
var baseReset = {
  margin: 0,
  // Reset browser default style.
  border: 'none',
  flexShrink: 0
};
var useStyledComponent = createUseStyledComponent(['hr'], 'csg-divider');
var Divider = /*#__PURE__*/React.forwardRef(function Divider(props, ref) {
  var _props$absolute = props.absolute,
    absolute = _props$absolute === void 0 ? false : _props$absolute,
    _props$as = props.as,
    component = _props$as === void 0 ? 'hr' : _props$as,
    _props$flexItem = props.flexItem,
    flexItem = _props$flexItem === void 0 ? false : _props$flexItem,
    _props$orientation = props.orientation,
    orientation = _props$orientation === void 0 ? 'horizontal' : _props$orientation,
    _props$light = props.light,
    light = _props$light === void 0 ? false : _props$light,
    _props$role = props.role,
    role = _props$role === void 0 ? component !== 'hr' ? 'separator' : undefined : _props$role,
    colorProps = props.color,
    bg = props.bg,
    backgroundColor = props.backgroundColor,
    height = props.height,
    _props$resetCss = props.resetCss,
    resetCss = _props$resetCss === void 0 ? EMPTY_OBJECT : _props$resetCss,
    width = props.width,
    children = props.children,
    rest = _objectWithoutProperties(props, _excluded);
  var theme = useSafeThemeUI(props);
  var _color = colorProps || bg || backgroundColor;
  var Component = useStyledComponent(component);
  var stringNodes = extractStringNodes(React.Children.toArray(children).filter(function (i) {
    return typeof i === 'string';
  }));
  var _resetCss = useMemo(function () {
    return _objectSpread2(_objectSpread2({}, omit(baseReset, Object.keys(resetCss))), resetCss);
  }, [resetCss]);
  var colors = useMemo(function () {
    var color = light ? getSafeTransparentize(0.5, resolveColor(theme, _color ? _color : 'neutral')) : resolveColor(theme, _color ? _color : 'neutral');
    return {
      bg: color,
      border: "1px solid ".concat(color)
    };
  }, [theme, _color, light]);
  return stringNodes.length > 0 && orientation === 'horizontal' ? /*#__PURE__*/React.createElement(BoxPrivate, {
    as: "fieldset",
    __css: {
      textAlign: 'center',
      margin: '0 auto',
      borderTop: colors.border,
      width: width !== null && width !== void 0 ? width : '50%'
    }
  }, /*#__PURE__*/React.createElement(TextPrivate, {
    as: "legend",
    lhCrop: "body",
    __css: {
      color: 'text',
      emPaddingX: 'xs'
    }
  }, stringNodes)) : /*#__PURE__*/React.createElement(Component, _extends({
    ref: ref,
    className: "csg-tui-divider",
    role: role,
    resetCss: _resetCss,
    __css: _objectSpread2(_objectSpread2(_objectSpread2({
      bg: colors.bg
    }, absolute ? {
      position: 'absolute',
      bottom: 0,
      left: 0,
      width: width || '100%'
    } : {}), orientation === 'vertical' ? {
      height: height ? height : '1em',
      width: width || '1px'
    } : {
      width: width || '100%',
      height: height || '1px'
    }), flexItem ? {
      alignSelf: 'stretch',
      height: height ? height : 'auto'
    } : {})
  }, rest));
});

export default Divider;
//# sourceMappingURL=divider.esm.js.map
